import * as React from "react"
import {useEffect, useMemo, useState} from "react"
import {useAppDispatch, useArtwork} from "../redux/stateHooks";
import {debounce} from "lodash";
import {setArtwork, setArtworkNotesPending} from "../redux/slices/addToCart";
import {NotesModel} from "../models/view/notesModel";

export const useNotesChange = () => {
    const dispatch = useAppDispatch();
    const artwork = useArtwork();
    const [notes, setNotes] = useState<string | undefined>(artwork?.notes);

    const debounceStateChange = useMemo(() => debounce((value?: string) => {
        dispatch(setArtwork({
            notes: value
        }));
        dispatch(setArtworkNotesPending(false));
    }, 1000), []);

    useEffect(() => () => debounceStateChange.cancel(), []);

    const onChange = ({target: {value}}: React.ChangeEvent<HTMLTextAreaElement>) => {
        const trimmedValue = value.replace(/ +(?= )/g, '').replace(/\n\s*\n/g, '\n');
        const normalizedValue = trimmedValue.length > 0 ? trimmedValue : undefined;
        setNotes(normalizedValue);
        dispatch(setArtworkNotesPending(true));
        debounceStateChange(normalizedValue);
    }

    return {model: new NotesModel(notes), onChange};
}